import React from "react";
import { Alert } from "reactstrap";
import MainLayout from "../Layout/MainLayout";
import Instructions from "../Shared/Instructions";
import ReviewModal from "../Shared/Modals/ReviewModal";
import FormContainer from "../Shared/FormContainer";
import RequestForm from "./RequestForm";
import DisplayState from "../Shared/DisplayState";
import ReviewData from "./ReviewData";

import modalMessages from "./config/modalMessages";
import defaultContainerState from "./config/defaultContainerState";
import { formatPhotoRequest } from "../util/formatRequestData";
import { validateInput } from "./config/validateInput";

export default function PhotoRequest() {
  return (
    <MainLayout
      sidebar={
        <Instructions
          instructionsHeaderText="About the Request Process"
          staffType="photography"
        />
      }
    >
      <section className="mb-3">
        <h1 className="display-4">Photo Request</h1>
        <Alert color="info">
          Please fill out a separate request for each event or project
        </Alert>

        <FormContainer
          formatRequest={formatPhotoRequest}
          defaultContainerState={defaultContainerState}
          formType="photo"
          validateInput={validateInput}
          render={containerState => {
            const {
              hideModal,
              onConfirmSubmit,
              resetFormState
            } = containerState;

            return [
              <RequestForm key="1" {...containerState} />,
              <ReviewModal
                key="2"
                show={containerState.formState.showModal}
                onGoBack={hideModal}
                onConfirmSubmit={onConfirmSubmit}
                userInput={containerState.userInput}
                messages={modalMessages}
                status={containerState.formState.requestStatus}
                ReviewComponent={ReviewData}
                resetForm={resetFormState}
                {...containerState}
              />,
              <DisplayState key="3" state={containerState.userInput} />,
              <DisplayState key="4" state={containerState.formState} />
            ];
          }}
        />
      </section>
    </MainLayout>
  );
}



// WEBPACK FOOTER //
// ./src/Photo/PhotoRequest.js